const STORAGE_KEY = "skipPreviousBiteConfirmation";

const safeSessionStorage = {
  get: (key: string): string | null => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      console.error(`Error reading ${key} from sessionStorage:`, error);
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error saving ${key} to sessionStorage:`, error);
    }
  },
  remove: (key: string): void => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing ${key} from sessionStorage:`, error);
    }
  },
};

export const getPreviousBiteConfirmationPreference = (): boolean =>
  safeSessionStorage.get(STORAGE_KEY) === "true";

export const setPreviousBiteConfirmationPreference = (skip: boolean): void =>
  safeSessionStorage.set(STORAGE_KEY, skip.toString());

export const clearPreviousBiteConfirmationPreference = (): void =>
  safeSessionStorage.remove(STORAGE_KEY);
